const MENU_TYPES = {
    DETAIL: "detail",
    VISIBILITY: "visibility",
    APPS: "apps",
    REVIEWS: "reviews",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.DETAIL,
        label: that && that.$t ? that.$t("appStore.detail") : "Detail",
        icon: {
            type: "material-icons",
            name: "info",
        },
    },
    {
        enabled: false,
        key: MENU_TYPES.VISIBILITY,
        label: that && that.$t ? that.$t("appStore.visibility") : "Visibility",
        icon: {
            type: "material-icons",
            name: "visibility",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.APPS,
        label: that && that.$t ? that.$t("appStore.apps") : "Apps",
        icon: {
            type: "material-icons",
            name: "apple",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.REVIEWS,
        label: that && that.$t ? that.$t("appStore.reviews") : "Reviews",
        icon: {
            type: "material-icons",
            name: "star",
        },
    },
];

export default {
    MENU_TYPES,
    Items,
};
